import Axios from 'axios'
import {groupBookingTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_group_booking_types (context) {
    Axios.get(groupBookingTypeUrls.getAllGroupBookingTypes).then(function (response) {
      context.commit('GET_ALL_GROUP_BOOKING_TYPES', response.data)
    })
  },
  get_group_booking_types (context, publicId) {
    Axios.get(groupBookingTypeUrls.getGroupBookingTypes + publicId).then(function (response) {
      context.commit('GET_GROUP_BOOKING_TYPES', response.data)
    })
  },
  get_deleted_group_booking_types (context) {
    Axios.get(groupBookingTypeUrls.getDeletedGroupBookingType).then(function (response) {
      context.commit('GET_DELETED_GROUP_BOOKING_TYPES', response.data)
    })
  },
  get_group_booking_type (context, publicId) {
    Axios.get(groupBookingTypeUrls.getGroupBookingType + publicId).then(function (response) {
      context.commit('GET_GROUP_BOOKING_TYPE', response.data)
    })
  },
  post_group_booking_type (context, data) {
    Axios.post(groupBookingTypeUrls.postGroupBookingType, data).then(function () {
      context.dispatch('get_all_group_booking_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_group_booking_type (context, data) {
    Axios.post(groupBookingTypeUrls.postGroupBookingType, data).then(function () {
      context.dispatch('get_all_group_booking_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  delete_group_booking_type (context, publicId) {
    Axios.get(groupBookingTypeUrls.deleteGroupBookingType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_GROUP_BOOKING_TYPES', response.data)
      router.push({
        name: 'Module.DeletedGroupBookingTypes'
      })
    })
  },
  restoreGroupBookingType (context, publicId) {
    Axios.get(groupBookingTypeUrls.restoreGroupBookingType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_GROUP_BOOKING_TYPES', response.data)
      router.push({
        name: 'Module.GroupBookingTypes'
      })
    })
  }
}
